export default __webpack_public_path__ + "static/media/bookmark-filled.5e21d93a.svg";